// extracted by mini-css-extract-plugin
export default {"locationInfo":"editMainTown_locationInfo__StF+u"};